export const meta = {
  id: 'A05',
  slug: 'minha-jornada',
  title: 'Como usar Minha Jornada',
  description: 'Use sua Jornada para entender onde você está, o que já concluiu e qual é o próximo passo.',
  profile: 'student',
  category: 'jornada',
  type: 'flow',
  status: 'published',
  order: 100,
  keywords: ['jornada', 'minha jornada', 'continuar jornada', 'trilha', 'progresso', 'próximo passo'],
  previous: 'A04',
  next: 'A06',
  related: ['A04', 'A06', 'A09'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Como usar Minha Jornada

A Jornada organiza experiências em uma sequência de desenvolvimento. Ela ajuda você a entender **onde está no percurso, o que já realizou e o que vem depois**.

## Como avançar

<Steps>
  <Step title="Abra Minha Jornada">
    Veja o percurso disponível e sua posição atual.
  </Step>
  <Step title="Use Continuar Jornada">
    Quando essa ação estiver disponível, ela direciona você para o próximo item do percurso.
  </Step>
  <Step title="Execute a experiência disponível">
    A Jornada pode conduzir a Treinamentos, Formações ou outras atividades vinculadas ao seu desenvolvimento.
  </Step>
  <Step title="Acompanhe o progresso">
    Depois de concluir uma etapa disponível, consulte novamente a Jornada para continuar.
  </Step>
</Steps>

<HelpImage alt="Minha Jornada com a ação Continuar Jornada" pendingId="A05.1" />

<Callout type="warning">
  Se uma experiência ainda não estiver disponível, isso pode fazer parte da sequência definida ou depender de um pré-requisito.
</Callout>
